import {
  AutocompleteInput,
  BooleanInput,
  Create,
  ReferenceInput,
  SimpleForm,
} from "react-admin";
import { statusChoices } from "../../utils/driver-schedule";
import DateFieldComponent from "../components/date-field-component";
import DivisionInput from "../components/division-input";
import { createTrucksFilterQuery } from "./common";
import { useLocation } from "react-router-dom";
import { SmartSelect } from "../components/smart-select";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export const DriverScheduleCreate = (props: any) => {
  const query = useQuery();
  const defaultDepartureDate = query.get("departureDate");

  return (
    <Create {...props}>
      <SimpleForm defaultValues={{ departureDate: defaultDepartureDate }}>
        <ReferenceInput source="driver" reference="fleetAssignments">
          <AutocompleteInput
            fullWidth
            optionText={(option) =>
              `${option.truck.licensePlate ?? option.truck.plate} - ${
                option.driver === null ? "未知司机" : option.driver.name
              } - ${option.source ?? `线下收集`}`
            }
            label="选择司机与货车（可输入车牌号快速查找）"
            filterToQuery={createTrucksFilterQuery}
            noOptionsText="无选项"
            style={{ maxWidth: "480px" }}
          />
        </ReferenceInput>
        <DivisionInput source="origin" label="始发站" />
        <DivisionInput source="destination" label="终点站" />
        <DateFieldComponent source="departureDate" label="出发日期" />
        <DateFieldComponent source="arrivalDate" label="到达日期" />
        <SmartSelect
          source="status"
          label="状态"
          choices={statusChoices}
          optionText="name"
          optionValue="id"
        />
        <BooleanInput source="isReturnTrip" label="为返程路线" />
      </SimpleForm>
    </Create>
  );
};
